var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 40,
    viewBox: "0 0 53 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1514 37.6825H21.0036V30.4346H13.1514V37.6825ZM14.3593 31.6425H19.7951V36.4746H14.3593V31.6425Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2119 37.6825H30.0641V30.4346H22.2119V37.6825ZM23.4198 31.6425H28.8557V36.4746H23.4198V31.6425Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2725 30.4346V37.6825H39.1247V30.4346H31.2725ZM37.9163 36.4746H32.4805V31.6425H37.9163V36.4746Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2311 21.9795H17.3789V29.2275H25.2311V21.9795ZM24.0232 28.0196H18.5874V23.1874H24.0232V28.0196Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2917 21.9795H26.4395V29.2275H34.2917V21.9795ZM33.0837 28.0196H27.6479V23.1874H33.0837V28.0196Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7747 15.3949L28.4332 0.234375H24.4466L-0.438477 15.3345L0.165703 16.3613L4.09153 14.0057V39.4344H48.184V13.9453L52.1099 16.3611L52.7747 15.3949ZM10.1318 18.9585H33.688V17.7506H10.1318V15.9384H42.1441V17.7506H35.4998V18.9585H42.1441V38.2867H10.1318V18.9585ZM46.9762 38.2867H43.3519V14.7304H8.92352V38.2867H5.29927L5.29969 13.2808L24.8091 1.44228L28.071 1.4427L46.9764 13.2208C46.976 13.2208 46.976 38.2871 46.976 38.2871L46.9762 38.2867Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.53e355303bed6c82d718a3e100d0263f.svg";
export { ForwardRef as ReactComponent };